import React from 'react';
import { trashOutline } from 'ionicons/icons';
import DataTable from '../../components/shared/DataTable/DataTable';

const TokensList = ({ 
  tokens = [], 
  loading = false, 
  onRevoke,
  onAdd,
  emptyStateButtonRef
}) => {
  const maskToken = (token) => {
    if (!token) return '—';
    return `${token}...`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const columns = [
    {
      header: 'NAME',
      key: 'name',
      className: 'data-table-name',
      render: (token) => token.name
    },
    {
      header: 'TOKEN',
      key: 'tokenPrefix',
      className: 'data-table-token',
      render: (token) => (
        <span className="token-copyable" title="Token prefix">
          <span className="token-text">{maskToken(token.tokenPrefix)}</span>
        </span>
      )
    },
    {
      header: 'CREATED',
      key: 'createdAt',
      className: 'data-table-date',
      render: (token) => formatDate(token.createdAt)
    }
  ];

  const actions = [
    {
      label: 'Revoke',
      icon: trashOutline,
      onClick: onRevoke,
      danger: true
    }
  ];

  return (
    <DataTable
      data={tokens}
      columns={columns}
      loading={loading}
      rowKey="tokenId"
      actions={actions}
      emptyState={{
        title: "No Tokens Yet",
        description: "Generate your first token to get started with CI/CD integration.",
        actionLabel: "Generate",
        onAction: onAdd,
        buttonRef: emptyStateButtonRef
      }}
    />
  );
};

export default TokensList;
